import React, { useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../auth-config';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import godrejLogo from '../../assets/images/godrej-logo-dark.svg';
import loginBgImage from '../../assets/images/IODlogo.jpg';
import config from '../../config';

const Login = () => {
  const { instance } = useMsal();
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async () => {
    setIsLoading(true);
    try {
      await instance.loginRedirect(loginRequest);
    } catch (error) {
      toast.error('Login failed. Please try again.');
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center my-3 logoHeader">
        <img src={godrejLogo} alt="Godrej Logo" />
        <span className="headerLink">Godrej Enterprises Group</span>
      </div>
      
      <Container fluid className="text-center vh-100 overflow-hidden">
        <Row className="align-items-start d-flex">
          <Col xs={12} md={8} className="noPadMar loginBg" style={{ backgroundImage: `url(${loginBgImage})` }}>
            {/* Login Image Background */}
          </Col>

          <Col xs={12} md={4} className="loginForm d-flex flex-column">
            <div className="text-start mb-4 godrejPurple">
              <h1>IOD</h1>
              <h5>Information of Delivery System</h5>
            </div>

            <Form>
              <Button
                type="button"
                className="w-100 rounded-pill mb-2"
                onClick={handleLogin}
                disabled={isLoading}
              >
                {isLoading ? 'Signing in...' : 'Login with Microsoft'}
              </Button>
              <p className="text-center mt-2 godrej-grey-70" style={{ fontSize: '0.8rem' }}>
                Use your organizational account to sign in securely
              </p>
            </Form>


          </Col>
        </Row>
      </Container>
      
      <ToastContainer position="top-right" />
    </>
  );
};

export default Login;
